import { useInitData, useNotification } from '../../../../../hooks'
import {
  ChatFormModal,
  getChatFormErrorNotification,
  getChatFormSuccessNotification,
} from '../../../../Chat'
import { useUserProfileContext } from '../../../../User'

import { getUserProfilePageChatFormInitialValues } from './useUserProfilePageSendMessageAction.utils'

export function useUserProfilePageSendMessageAction() {
  const { handleCloseModal, setModal, userData } = useUserProfileContext()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const { availableSections } = useInitData()

  function handleErrorCreation() {
    handleAddErrorNotification(getChatFormErrorNotification())
  }

  function handleSuccessCreation(data) {
    handleCloseModal()
    handleAddSuccessNotification(
      getChatFormSuccessNotification({ ...data, availableSections })
    )
  }

  function handleClickSendMessage() {
    setModal(
      <ChatFormModal
        initialValues={getUserProfilePageChatFormInitialValues(userData)}
        onClose={handleCloseModal}
        onError={handleErrorCreation}
        onSuccess={handleSuccessCreation}
      />
    )
  }

  return { handleClickSendMessage }
}
